<div class=" p-2 min-w-[80%]">
	<div class="flex items-center gap-2 mb-5">
		<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg" width="40" height="40" alt="Anuprerna">
		<h1 class="text-2xl uppercase text-[#8E7862]">Anuprerna</h1>
	</div>
	<div class="fb-login-form-container flex flex-col items-stretch">
		<div class="flex gap-2 items-center">
			<span (click)="authProvider.emit(AuthProviderEnum.UNKNOWN)"
				  class="material-symbols-outlined cursor-pointer">
				arrow_back_ios
			</span>
			<h3 class="font-medium text-2xl mb-2">Create your account</h3>
		</div>
		<p class="text-[#9fa6b8]">You are creating an account with <span class="text-black">{{emailFormControl.value}}</span></p>
		<div class="fb-login-form my-3">
			<form [formGroup]="registrationFormGroup" (ngSubmit)="basicRegister()">
				<div class="flex justify-between items-center gap-2 my-2.5">
					<div class="">
						<label for="f-name" class="text-sm font-bold">First Name :</label>
						<input class="w-full px-2 py-2 border border-[##F0F5FA] rounded"
							   type="text"
							   id="f-name"
							   name="firstname"
							   [formControl]="firstNameControl"
							   placeholder="First Name"/>
						<ng-container>
							<p class="text-red-500 text-xs"
							   *ngIf="registrationFormGroup.controls['firstName'].invalid &&
									   registrationFormGroup.controls['firstName'].dirty">
								First name is required.
							</p>
						</ng-container>
					</div>
					<div class="">
						<label for="l-name" class="text-sm font-bold">Last Name :</label>
						<input class="w-full px-2 py-2 border border-[##F0F5FA] rounded"
							   type="text"
							   id="l-name"
							   name="lastname"
							   [formControl]="lastNameControl"
							   placeholder="Last Name"/>
						<ng-container>
							<p class="text-red-500 text-xs"
							   *ngIf="registrationFormGroup.controls['lastName'].invalid &&
									   registrationFormGroup.controls['lastName'].dirty">
								Last name is required.
							</p>
						</ng-container>
					</div>
				</div>

				<div class="my-2.5">
					<label for="password" class="text-sm font-bold">Password :</label>
					<div class="w-full border border-[##F0F5FA] rounded flex items-center justify-between gap-0.5 pr-2">
						<input class="w-full px-2 py-2"
							   [type]="passwordType"
							   id="password"
							   name="password"
							   [formControl]="passwordFormControl"
							   placeholder="Enter your password"/>
						<div (click)="passwordType==='text'? passwordType='password': passwordType='text'"
							 class="cursor-pointer">
										<span *ngIf="passwordType==='password'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility</span>
							<span *ngIf="passwordType==='text'"
								  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility_off</span>
						</div>
					</div>
					<ng-container>
						<p class="text-red-500 text-xs"
						   *ngIf="registrationFormGroup.controls['password'].invalid &&
									   registrationFormGroup.controls['password'].dirty">
							Password is required. Minimum 8 characters.
						</p>
					</ng-container>
				</div>
				<div class="my-2.5">
					<label for="c-password" class="text-sm font-bold">Confirm Password :</label>
					<div class="w-full border border-[##F0F5FA] rounded flex items-center justify-between gap-0.5 pr-2">
						<input class="w-full px-2 py-2 "
							   [type]="confirmPasswordType"
							   id="c-password"
							   name="confirm-password"
							   [formControl]="confirmPasswordFormControl"
							   placeholder="Re-Enter your password"/>
						<div (click)="confirmPasswordType==='text'? confirmPasswordType='password': confirmPasswordType='text'"
							 class="cursor-pointer">
										<span *ngIf="confirmPasswordType==='password'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility</span>
							<span *ngIf="confirmPasswordType==='text'"
								  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility_off</span>
						</div>
					</div>
					<ng-container>
						<p class="text-red-500 text-xs"
						   *ngIf="confirmPasswordFormControl.dirty &&(passwordFormControl.value !== confirmPasswordFormControl.value)">
							Confirm Password does not match with Password
						</p>
					</ng-container>
				</div>
				<button class="w-full mt-5 rounded bg-[#8E7862] text-white py-2 hover:bg-[#6c5b48] transition-colors"
						type="submit">
					Sign Up
				</button>
			</form>

			<div *ngIf="isSuccessfull"
				 class="px-2 mt-5 py-2 shadow flex gap-4 items-center justify-between border border-[#8E7862]/20 rounded">
				<span class="material-symbols-outlined">
					celebration
				</span>
				<div>
					Thank You for creating an account. Please check your email inbox / SPAM to
					verify. In case you have not received any email for verification,
					<span class="underline cursor-pointer"
						  (click)="resendEmail()">here</span> to resend
					the mail.
				</div>
			</div>
		</div>
	</div>
</div>
